let linksTitle = [
    {id: 1, title: "All", pathName: "all" },
    {id: 2, title: "Mac", pathName: "mac" },
    {id: 3, title: "iPhone", pathName: "iphone"},
    {id: 4, title: "iPad", pathName: "ipad" },
    {id: 5, title: "Accessories", pathName: "accessories" },
]

export default linksTitle